import FreespinIdle from "slotworks/state-machine/standard/states/freespin-idle";

export default class GameiomFreespinIdle extends FreespinIdle {

}
